<div class="row">
    <div class="col-12 text-center">
        <h2>{{ 'pages.tenants.select' | translate }}</h2>
        <p>{{ 'pages.tenants.update' | translate }}</p>

        <h4>{{ 'pages.tenants.current' | translate }}: {{selectedTenant}}</h4>
    </div>
</div>
<form>
    <div class="form-row justify-content-center text-center">
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-3">            
            <select class="form-control mb-3" name="tenant" aria-describedby="selectTenant" [(ngModel)]="tenantToSelect">
                <!-- <option hidden>Change Tenant</option> -->
                <option value="{{ten}}" *ngFor="let ten of availableTenants">{{ten}}</option>
            </select>
            
            <button class="btn btn-primary" (click)="selectTenant(confirmModal);">Change Tenant</button>
        </div>
    </div>
</form>


<ng-template #confirmModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.confirm' | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="text-align: center">
        <form>  
            <p>{{ 'pages.tenants.confirm' | translate }} <b>{{tenantToSelect}}</b>?</p>
            <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="switch(); d();">Confirm</button>
                <button type="button" class="btn btn-primary" (click)="d()"> Cancel</button>
            </div>
        </form>
    </div>
</ng-template>

